<div ngbDropdown class="d-inline-block">
  <wsb-atlas-button [variant]="variant"
                    class="d-block"
                    [label]="label"
                    [size]="size"
                    [roundButton]="roundButton" ngbDropdownToggle></wsb-atlas-button>
  <div class="w-100 dropdown-truncate" ngbDropdownMenu>
    <ng-content></ng-content>
  </div>
</div>
